import { type PillarFormSelectOption } from "shared/components/pillar-form/components/PillarFormSelectMenu";
import { type PillarFormInputComponentConfig } from "shared/components/pillar-form/PillarFormInputComponentConfig";

/**
 * SurveyJS-like choice shape for `select` elements. Choices can be plain
 * values ("CertificateEarned") or objects carrying a separate display label.
 */
export type PillarFormDynamicChoice =
  | string
  | number
  | {
      value: string | number;
      text?: string;
      label?: string;
      title?: string;
      disabled?: boolean;
    };

/**
 * Normalize the surveyjs-like `choices` on a config element into the option
 * shape PillarFormSelectMenu expects.
 */
export const normalizeDynamicSelectChoices = (
  element: PillarFormInputComponentConfig,
): PillarFormSelectOption[] => {
  const rawChoices = element.choices ?? element.options;

  if (!Array.isArray(rawChoices)) {
    return [];
  }

  return rawChoices.reduce<PillarFormSelectOption[]>((acc, rawChoice) => {
    if (rawChoice === null || rawChoice === undefined) {
      return acc;
    }

    if (typeof rawChoice !== "object") {
      const value = rawChoice as string | number;
      acc.push({ label: String(value), value });
      return acc;
    }

    const choice = rawChoice as Record<string, unknown>;
    const value = choice.value as string | number | undefined;

    if (value === undefined) {
      return acc;
    }

    const label = choice.text ?? choice.label ?? choice.title ?? value;

    acc.push({
      label: String(label),
      value,
      disabled: Boolean(choice.disabled),
    });
    return acc;
  }, []);
};
